import utils from 'utils';
import { store } from 'src/redux/store';

export default {
  // 获取活动详情
  getPromotionDetail() {
    return this.http('api', 'get', '/shop-interface/v1/promotion/flash_sale_list');
  },
  lottery() {
    const { token } = store.getState();
    const headers = utils.getHeadersInToken(token);
    return this.http('Lottery', 'post', '/api/v2/lotteries', '', headers);
  },

  checkLottery() {
    const { token } = store.getState();
    const headers = utils.getHeadersInToken(token);
    return this.http(
      'Lottery',
      'get',
      '/api/v2/lotteries/today',
      '',
      headers
    );
  },
  getAdviser() {
    return this.http(
      'Lottery',
      'get',
      '/api/v1/users/weixin_consultant'
    );
  }
};
